import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from '../../contexts/TranslationContext';

gsap.registerPlugin(ScrollTrigger);

const Hero: React.FC = () => {
    const { t } = useTranslation();
    const heroRef = useRef<HTMLDivElement>(null);
    const bgRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            // Parallax effect
            gsap.to(bgRef.current, {
                scrollTrigger: {
                    trigger: heroRef.current,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                },
                y: 100,
                ease: "none"
            });

            // Text reveal
            gsap.from(".hero-content > *", {
                opacity: 0,
                y: 30,
                duration: 1.2,
                stagger: 0.2,
                ease: "power4.out"
            });
        }, heroRef);
        return () => ctx.revert();
    }, []);

    return (
        <div ref={heroRef} className="relative h-[21vh] w-full overflow-hidden flex items-center justify-center">
            {/* Background Image with Overlay */}
            <div
                ref={bgRef}
                className="absolute inset-0 z-0 scale-[3]"
                style={{
                    backgroundImage: "url('https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=2000&auto=format&fit=crop')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="absolute inset-0 bg-earth-dark/50 backdrop-blur-[16px]" />
            </div>

            <div className="hero-content relative z-10 text-center px-6 max-w-4xl space-y-1">
                <h1 className="text-white text-2xl md:text-3xl font-sans font-light tracking-wide lowercase italic opacity-90">
                    {t('welcome_title')}
                </h1>
                <div className="h-[1px] w-12 bg-burgundy/40 mx-auto rounded-full" />
                <p className="text-white/60 text-xs md:text-sm font-sans font-light tracking-wide max-w-xl mx-auto leading-relaxed">
                    {t('welcome_message')}
                </p>
            </div>
        </div>
    );
};

export default Hero;
